import swiper from "swiper";

jQuery(document).ready(function () {
  if ($('.top-hero').length) {
    var aidSlider = new swiper(".top-hero__slider", {
      // direction: "horizontal",
      loop: true,
      speed: 500,
      spaceBetween: 0,
      centeredSlides: true,
      observer: true,
      allowTouchMove: false,
      preloadImages: false,
      // autoHeight: true,
      // slidesPerView: 1.7,
      slidesPerView: 1,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 4
      },
      effect: "fade",
      slideToClickedSlide: false,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      // pagination: {
      //   el: ".swiper-pagination",
      //   clickable: true
      // },
      breakpoints: {
        // 1120: {
        //   slidesPerView: 1.7
        // },
        // 768: {
        //   spaceBetween: 20,
        //   slidesPerView: 1.295
        // },
        // 414: {
        //   autoHeight: false,
        //   slidesPerView: 1
        // }
      },
      // navigation: {
      //   nextEl: '.aid-slide-next',
      //   prevEl: '.aid-slide-prev',
      // }
    });
  }
});
